import Icon from '@ant-design/icons';
import { MouseEventHandler } from 'react';

interface IProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
}

export const DrawerCloseSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="white" />
                <path
                    d="M9.86902 7.60937L14.2596 12L9.86902 16.3906"
                    stroke="#9655FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )}
    />
);

export const ModalCloseSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_143_14090)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.5661 3.13788C12.8265 3.39824 12.8265 3.82037 12.5661 4.08072L8.79492 7.85148L12.5662 11.6232C12.8265 11.8835 12.8265 12.3056 12.5662 12.566C12.3058 12.8263 11.8837 12.8263 11.6233 12.5659L7.85211 8.79429L4.08087 12.5659C3.82052 12.8263 3.39839 12.8263 3.13804 12.566C2.8777 12.3056 2.87768 11.8835 3.13801 11.6232L6.9093 7.85148L3.13811 4.08072C2.87774 3.82037 2.87773 3.39824 3.13809 3.13788C3.39843 2.87754 3.82052 2.87753 4.08087 3.13786L7.85211 6.90867L11.6233 3.13786C11.8837 2.87753 12.3058 2.87754 12.5661 3.13788Z"
                        fill="#1B1B48"
                    />
                </g>
            </svg>
        )}
    />
);

export const SuccessOfToastSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="10" fill="#8DD25D" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0452 5.23328C16.4357 5.62384 16.4356 6.25701 16.0451 6.6475L8.54501 14.1461C8.15447 14.5366 7.52133 14.5366 7.13084 14.146L4.13123 11.1462C3.74072 10.7557 3.74075 10.1225 4.13129 9.732C4.52183 9.34149 5.15499 9.34151 5.5455 9.73205L7.83807 12.0248L14.631 5.23315C15.0216 4.84266 15.6547 4.84272 16.0452 5.23328Z"
                    fill="white"
                />
            </svg>
        )}
    />
);

export const WarningOfToastSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10.0176" r="10" fill="#FF5E5E" />
                <path
                    d="M8.84458 4.80534C8.81215 4.14497 9.33882 3.5918 9.99998 3.5918C10.6611 3.5918 11.1878 4.14497 11.1554 4.80533L10.8025 11.9897C10.7815 12.4176 10.4284 12.7538 9.99998 12.7538C9.57154 12.7538 9.21847 12.4176 9.19745 11.9897L8.84458 4.80534ZM9.99098 13.7258C10.387 13.7258 10.729 13.8518 10.999 14.1038C11.251 14.3558 11.395 14.6798 11.395 15.0758C11.395 15.4718 11.251 15.8138 10.999 16.0658C10.711 16.3178 10.387 16.4438 9.99098 16.4438C9.59498 16.4438 9.27098 16.2998 9.01898 16.0478C8.73098 15.7958 8.60498 15.4718 8.60498 15.0758C8.60498 14.6798 8.73098 14.3558 9.01898 14.1038C9.27098 13.8518 9.59498 13.7258 9.99098 13.7258Z"
                    fill="white"
                />
            </svg>
        )}
    />
);

export const SubjectSearchItemIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_ii_203_4166)">
                    <path
                        d="M1.11133 7.77775C1.11133 4.09585 4.0961 1.11108 7.77799 1.11108H12.2224C15.9043 1.11108 18.8891 4.09585 18.8891 7.77775V16.6666C18.8891 17.8939 17.8942 18.8889 16.6669 18.8889H7.77799C4.0961 18.8889 1.11133 15.9041 1.11133 12.2222V7.77775Z"
                        fill="url(#paint0_linear_203_4166)"
                    />
                </g>
                <path
                    d="M7.49984 5.7312C7.4628 5.7312 7.44428 5.80528 7.44428 5.95342V7.17565C7.44428 7.32379 7.4628 7.39787 7.49984 7.39787H5.1665C5.20354 7.39787 5.22206 7.32379 5.22206 7.17565V5.95342C5.22206 5.80528 5.20354 5.7312 5.1665 5.7312H7.49984ZM14.6665 12.9979C14.6665 13.6497 14.5887 14.1312 14.4332 14.4423C14.285 14.7608 14.0109 14.9793 13.6109 15.0979C13.2109 15.2238 12.5998 15.2868 11.7776 15.2868C11.6295 15.2868 11.5554 15.3053 11.5554 15.3423V13.6756C11.5554 13.7127 11.6295 13.7312 11.7776 13.7312C12.148 13.7312 12.4072 13.6793 12.5554 13.5756C12.7035 13.4719 12.7776 13.2645 12.7776 12.9534V7.50898H8.22206C8.07391 7.50898 7.99984 7.5275 7.99984 7.56453V5.7312C7.99984 5.76824 8.07391 5.78676 8.22206 5.78676H14.6665V12.9979ZM7.22206 7.89787C7.18502 7.89787 7.1665 7.97194 7.1665 8.12009V15.0645C7.1665 15.2127 7.18502 15.2868 7.22206 15.2868H5.27761C5.31465 15.2868 5.33317 15.2127 5.33317 15.0645V8.12009C5.33317 7.97194 5.31465 7.89787 5.27761 7.89787H7.22206ZM12.1665 13.1201H7.83317V8.34231H12.1665V13.1201ZM10.4998 11.5645V9.89787H9.49984V11.5645H10.4998Z"
                    fill="white"
                />
                <defs>
                    <filter
                        id="filter0_ii_203_4166"
                        x="-2.88867"
                        y="-2.88892"
                        width="21.7778"
                        height="25.7778"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.920741 0 0 0 0 1 0 0 0 0 0.405555 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_203_4166" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dx="-4" dy="-4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.67875 0 0 0 0 0.286111 0 0 0 1 0" />
                        <feBlend mode="normal" in2="effect1_innerShadow_203_4166" result="effect2_innerShadow_203_4166" />
                    </filter>
                    <linearGradient
                        id="paint0_linear_203_4166"
                        x1="0.0316531"
                        y1="1.11108"
                        x2="18.8891"
                        y2="17.6724"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFBA61" />
                        <stop offset="1" stopColor="#FCD48B" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);
